module.exports = __webpack_public_path__ + "static/eamnbg-77758ed2d715eea10836594e98bdf967.jpg";